var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-autocomp-grouped-select',{ref:"innerComp",attrs:{"options":_vm.get_product,"placeholder":_vm._value,"debounce":1000,"skip-input-when-actionable":_vm.skipInputWhenActionable},on:{"searchchange":_vm.load_product},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }